<template>
  <div v-if="visible" class="pycad-vr-boot">
    <div class="pycad-vr-boot__card">
      <i class="mdi mdi-loading pycad-vr-boot__spinner" aria-hidden="true"></i>
      <div class="pycad-vr-boot__title">Building volume render</div>
      <div class="pycad-vr-boot__subtitle">
        Compiling shaders and uploading textures…
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ visible: boolean }>();
</script>

<style scoped>
.pycad-vr-boot {
  position: absolute;
  inset: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  background: radial-gradient(
    ellipse at center,
    rgba(10, 10, 14, 0.72) 0%,
    rgba(0, 0, 0, 0.88) 100%
  );
}

.pycad-vr-boot__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 18px 24px;
  border-radius: 12px;
  background: rgba(22, 24, 32, 0.94);
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.55);
  font-family: 'Inter', system-ui, sans-serif;
  text-align: center;
  max-width: 280px;
}

.pycad-vr-boot__spinner {
  font-size: 28px;
  color: #ffc800;
  animation: pycad-vr-boot-spin 0.9s linear infinite;
}

.pycad-vr-boot__title {
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
}

.pycad-vr-boot__subtitle {
  font-size: 11px;
  line-height: 1.45;
  color: #a0a0a0;
}

@keyframes pycad-vr-boot-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
